<template>
  <div class="card-select">
    <Grid :column-num="3" :border="false">
      <GridItem v-for="(subitem, subindex) in formValue" :key="subindex">
        <div
          class="card-select-card-item"
          :class="{
            active: selectActiveCard == subitem.id,
            small: sizeType == 'small',
            middle: sizeType == 'middle',
          }"
          @click="selectActiveCard = subitem.id"
        >
          <VanImage
            height="100%"
            :src="subitem.isFront != 1 ? subitem.reverseImg : subitem.frontImg"
            fit="fill"
            radius="5"
          />
          <div
            class="card-select-card-item-open"
            @click.stop="previewImgHandle(subitem)"
          >
            <Icon name="search" size="0.3rem" />
          </div>
        </div>
      </GridItem>
    </Grid>
    <!-- 选中的卡片按钮 -->
    <div class="card-select-btns" v-show="gameStatus == 1">
      <NfButton
        v-if="showReturn"
        color="rgb(255,211,94)"
        round=".5rem"
        style="margin-top: 0.2rem"
        class="card-select-btns-btn"
        @click.native="revertCardHandle"
        >放回卡片</NfButton
      >

      <NfButton
        color="rgb(172,185,233)"
        round=".5rem"
        style="margin-top: 0.2rem"
        class="card-select-btns-btn"
        @click.native="confirmHandle"
        >确认选择</NfButton
      >
    </div>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Image as VanImage,
  Grid,
  GridItem,
  Icon,
  ImagePreview,
} from "vant";
import NfButton from "@/components/game-ui/NfButton.vue";
export default {
  data() {
    return {
      selectActiveCard: 0,
    };
  },
  components: {
    VanImage,
    Swipe,
    SwipeItem,
    Grid,
    GridItem,
    NfButton,
    Icon,
    ImagePreview,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: "",
        };
      },
    },
    gameInfo: {
      type: Object,
      default: () => {
        return {
          gameId: "",
          gameRoundId: "",
        };
      },
    },
    userInfo: {
      type: Object,
      default: () => {
        return {
          uid: "",
        };
      },
    },
    playerId: {
      type: String,
      default: "",
    },
    playerName: {
      type: String,
      default: "",
    },
    showReturn: {
      type: Boolean,
      default: true,
    },
    gameStatus: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    formValue: {
      get() {
        return this.value;
      },
      set(val) {
        console.log("改变了");
        this.$emit("update:value", {
          ...val,
        });
      },
    },
  },
  watch: {
    value: {
      handler(val) {
        // console.log("val66666666", val);
        // this.formValue.selectIdList = (val || []).map((item) => item.id);
        // console.log("val.selectIdList", val.selectIdList);
        const selectIdList = val.map((item) => item.id);
        this.$emit("update:selectIdList", selectIdList);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    revertCardHandle() {
      const index = this.formValue.findIndex(
        (item) => item.id == this.selectActiveCard
      );
      if (index != -1) {
        console.log("放回");
        this.formValue.splice(index, 1);
        this.$emit("putCard", index);
      } else {
        this.$dialog.message("请选择需要放回的卡牌");
      }
    },
    confirmHandle() {
      // 如果为空
      if (this.formValue.length == 0) {
        this.$dialog.message("请选择卡牌");
        return;
      }

      const data = this.formValue.map((item) => {
        return {
          cardId: item.id,
          cardName: item.cardName,
          cateId: item.cateId,
          cateName: item.cateName,
          createTime: item.createTime,
          secondCateId: item.secondCateId,
          secondCateName: item.secondCateName,
          roundId: this.gameInfo.gameRoundId,
          gameId: this.gameInfo.gameId,
          playerId: this.playerId,
          playerName: this.playerName,
          userId: this.userInfo.uid,
        };
      });

      this.$emit("confirm", data);
    },
    previewImgHandle(item) {
      const img = item.brandStatus ? item.reverseImg : item.frontImg;
      ImagePreview({
        images: [img],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-select {
  &-btns {
    display: flex;
    justify-content: space-between;
    margin-top: 0.2rem;
    &-btn {
      margin: 0 0.2rem;
    }
  }

  &-card-item {
    box-sizing: border-box;
    border-radius: 0.2rem;
    // overflow: hidden;
    height: 2.8rem;
    position: relative;
    &-open {
      position: absolute;
      top: -0.15rem;
      right: -0.15rem;
      border-radius: 50%;
      width: 0.6rem;
      height: 0.6rem;
      background: #eee;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .small {
    height: 2.2rem;
  }

  .middle {
    height: 2.5rem;
  }
  .active {
    border: 0.06rem solid #666eee;
  }
}
</style>

<style>
.van-grid {
  justify-content: center;
}
::v-deep .van-grid-item__content {
  background-color: inherit !important;
}
</style>
